/**
 * @flow
 * @author: Preethi
 */

class UIStore {
  mobileSBFormModalRef = null
  formMobileRef = null

  setMobileSBFormModalRef = ref => {
    this.mobileSBFormModalRef = ref
  }

  getMobileSBFormModalRef = () => this.mobileSBFormModalRef

  captureFormMobileRef = ref => {
    this.formMobileRef = ref
  }

  getFormMobileRef = () => this.formMobileRef
}

const uiStore = new UIStore()

export default uiStore



// WEBPACK FOOTER //
// ./src/utils/UIStore.js